import { call, select } from 'redux-saga/effects';
import nsToken from '@netsapiens/netsapiens-js/dist/token';
import nsApi from '@netsapiens/netsapiens-js/dist/api';
import bugsnagClient from '../../services/bugsnag/bugsnag';
import { unsubPush } from '../../utils/push';
import { selectWebphoneDevice } from '../../state/webphoneDevice/webphoneDeviceSlice';

/**
 * Generates a random password for SIP device
 * @returns {string} Random password
 */
function generateDevicePassword() {
  const chars = 'AbcDE123IJKLMN67QRSTUVWXYZaBCdefghijklmn123opq45rs67tuv89wxyz0FGH45OP89';
  const seed = chars + chars + chars; // Repeat to increase randomness
  let password = '';
  for (let i = 0; i < 16; i += 1) {
    password += seed.charAt(Math.floor(Math.random() * seed.length));
  }
  return password;
}

/**
 * Updates the user's WebPhone device with the specified suffix
 * This saga is used to reset/update device configuration, particularly
 * when taking over a device that's already registered elsewhere
 *
 * @param {string} devicePostFix - The suffix to append to the device URI
 */
export default function* updateWPDevice(devicePostFix) {
  const decodedToken = yield call(nsToken.getDecoded);

  try {
    const deviceUri = `sip:${decodedToken.user}${devicePostFix}@${decodedToken.domain}`;

    console.debug('updateWPDevice: Starting device update', {
      deviceUri,
      domain: decodedToken.domain,
      user: decodedToken.user,
    });

    // Prepare device update parameters
    const deviceParams = {
      device: deviceUri,
      domain: decodedToken.domain,
      userId: decodedToken.user,
      authentication_key: generateDevicePassword(),
    };

    // Update the SIP device
    const updatedDevice = yield call(nsApi.post, {
      object: 'device',
      action: 'update',
      ...deviceParams,
    });

    console.debug('updateWPDevice: Device updated successfully', updatedDevice);
    // unregister the push notifications
    const fetchAudioTaskRes = yield select(selectWebphoneDevice);
    yield call(unsubPush, fetchAudioTaskRes);

    return {
      success: true,
      device: deviceParams,
      deviceUri,
    };
  } catch (error) {
    console.error('updateWPDevice: Failed to update WebPhone device', error);
    bugsnagClient.notify(error);

    return {
      success: false,
      error: error.message,
    };
  }
}
